// src/notifications.ts
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";

export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("❌ Permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });
    if (token) {
      localStorage.setItem("fcm_token", token);
      return token;
    }

    return null;
  } catch (error) {
    console.error("❌ Error getting token:", error);
    return null;
  }
};

export const initNotifications = async (): Promise<void> => {
  await requestNotificationPermission();
};
